/**
 * @generated SignedSource<<081d30781a2f1d5b632fb6876742f4a6>>
 * @relayHash a22eabfcf30a047d4253b0d298b5d5f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 106da493e584c903f47687b25a4b28244e0f9e7e45f5ce8d422a2d3a5dd50485

import type { ConcreteRequest } from 'relay-runtime';
export type InteractiveHierarchyModalQuery$variables = {
  aaid: string;
  orgId: string;
  siteId: string;
};
export type InteractiveHierarchyModalQuery$data = {
  readonly knowledgeDiscovery: {
    readonly reportingLines: {
      readonly __typename: "KnowledgeDiscoveryReportingLines";
      readonly managers: ReadonlyArray<{
        readonly accountIdentifier: string | null | undefined;
        readonly numberOfDirectReports: number | null | undefined;
        readonly numberOfTotalReports: number | null | undefined;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly picture: string | null | undefined;
        } | null | undefined;
      }>;
      readonly peers: ReadonlyArray<{
        readonly accountIdentifier: string | null | undefined;
        readonly numberOfDirectReports: number | null | undefined;
        readonly numberOfTotalReports: number | null | undefined;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly picture: string | null | undefined;
        } | null | undefined;
      }>;
      readonly reports: ReadonlyArray<{
        readonly accountIdentifier: string | null | undefined;
        readonly numberOfDirectReports: number | null | undefined;
        readonly numberOfTotalReports: number | null | undefined;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly picture: string | null | undefined;
        } | null | undefined;
      }>;
      readonly user: {
        readonly accountIdentifier: string | null | undefined;
        readonly numberOfDirectReports: number | null | undefined;
        readonly numberOfTotalReports: number | null | undefined;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly picture: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type InteractiveHierarchyModalQuery = {
  response: InteractiveHierarchyModalQuery$data;
  variables: InteractiveHierarchyModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ]
  }
],
v2 = [
  {
    "concreteType": "KnowledgeDiscoveryQueryApi",
    "kind": "LinkedField",
    "name": "knowledgeDiscovery",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "aaid"
          },
          {
            "kind": "Variable",
            "name": "orgId",
            "variableName": "orgId"
          },
          {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteId"
          }
        ],
        "kind": "LinkedField",
        "name": "reportingLines",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "managers",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "reports",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "peers",
                "plural": true,
                "selections": (v1/*: any*/)
              }
            ],
            "type": "KnowledgeDiscoveryReportingLines"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InteractiveHierarchyModalQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InteractiveHierarchyModalQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "106da493e584c903f47687b25a4b28244e0f9e7e45f5ce8d422a2d3a5dd50485",
    "metadata": {},
    "name": "InteractiveHierarchyModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "423257cd5875e787591bfebf1db4e32e";

export default node;
